"use client";

import { useAuth, useWallet } from "@crossmint/client-sdk-react-ui";
import { PaymentFlow } from "./PaymentFlow";

export function AddFundsPage() {
  const { user } = useAuth();
  const { wallet } = useWallet();

  return (
    <div className="min-h-screen max-w-5xl scrollbar-hide mx-auto bg-gradient-to-br from-[#090D14] via-[#0A0E15] to-[#0B0F16] text-white p-4 sm:p-6 md:p-8">
      <div className="w-full space-y-6 sm:space-y-8">
        <div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
            Add Funds
          </h1>
          <p className="text-gray-400 text-sm sm:text-base md:text-lg">
            Top up your wallet with USD on Base using your preferred payment
            method
          </p>
        </div>
        <PaymentFlow
          targetWalletAddress={wallet?.address || ""}
          payerEmail={user?.email || null}
          showWalletDisplay={true}
          showManagePayments={true}
        />
      </div>
    </div>
  );
}

export default AddFundsPage;
